function initSelect(){
  const selectActions = {
    close: 0,
    closeSelect: 1,
    first: 2,
    last: 3,
    next: 4,
    previous: 5,
    open: 6,
    search: 7,
  };

  const selectedClass = "selected";

  const getActionFromKey = (event: KeyboardEvent, isOpen: boolean) => {
    const { key, altKey, ctrlKey, metaKey } = event;
    const openKeys = ["ArrowDown", "ArrowUp", "Enter", " "];

    const isPrintableKey = key.length === 1 && key !== " " && !altKey && !ctrlKey && !metaKey;

    if (!isOpen && openKeys.includes(key)) {
      return selectActions.open;
    }

    const keyMap: Record<string, () => number | undefined> = {
      Home: () => selectActions.first,
      End: () => selectActions.last,
      Backspace: () => selectActions.search,
      Clear: () => selectActions.search,
    };

    if (key in keyMap) {
      return keyMap[key]();
    }

    if (isPrintableKey) {
      return selectActions.search;
    }

    if (!isOpen) return;

    const openKeyMap: Record<string, () => number | undefined> = {
      ArrowUp: () => (altKey ? selectActions.closeSelect : selectActions.previous),
      ArrowDown: () => (!altKey ? selectActions.next : undefined),
      PageUp: () => selectActions.first,
      PageDown: () => selectActions.last,
      Escape: () => selectActions.close,
      Enter: () => selectActions.closeSelect,
      Space: () => selectActions.closeSelect,
    };

    return openKeyMap[key]?.();
  };


  const epiServerFormSelectEls = document.querySelectorAll<HTMLElement>(".Form__Element.CustomFormSelection");

  epiServerFormSelectEls.forEach(el => {
    el.dataset.initilized = 'true';

    const nativeSelect = el.querySelector<HTMLSelectElement>(".FormSelection__Native-Select")!;

    if (nativeSelect.multiple) return;

    const customSelect = el.querySelector<HTMLElement>(".FormSelection__Custom-Select")!;
    const selectedText = customSelect.querySelector<HTMLElement>(".FormSelection__Selected-Text")!;
    const optionsBox = el.querySelector<HTMLElement>(".FormSelection__Custom-Options")!;
    const options = Array.from(optionsBox.querySelectorAll<HTMLElement>(".FormSelection__Custom-Option"));
    let activeIndex = options.findIndex(option => option.classList.contains("selected")) ?? 0;

    const isExpanded = () => customSelect.getAttribute("aria-expanded") === "true";

    const expand = () => {
      customSelect.setAttribute("aria-expanded", "true");
      optionsBox.style.display = "block";

      focusOption(getSelectedOption());
    };

    const setCustomSelectActiveDescendant = (id: string | undefined) => {
      customSelect.setAttribute("aria-activedescendant", id ?? "");
    };

    const collapse = () => {
      customSelect.setAttribute("aria-expanded", "false");
      optionsBox.style.display = "none";
      setCustomSelectActiveDescendant(undefined);
    };

    const getSelectedOption = () => optionsBox.querySelector<HTMLElement>(".FormSelection__Custom-Option.selected");

    const handleUnselectOtherOptions = (id: string) => {
      options.forEach(opt => {
        if (opt.id === id) return;
        opt.classList.remove(selectedClass);
        opt.ariaSelected = "false";
      });
    };

    const selectOption = (option: HTMLElement) => {
      const value = option.getAttribute("data-value")!;

      selectedText.textContent = option.textContent ?? "";
      nativeSelect.value = value;
      nativeSelect.dispatchEvent(new Event("change", { bubbles: true }));

      handleUnselectOtherOptions(option.id);

      option.classList.add(selectedClass);
      option.ariaSelected = "true";
      collapse();
      customSelect.focus();
      activeIndex = options.indexOf(option);
    };

    const focusOption = (option: HTMLElement | undefined | null) => {
      option?.focus();

      setCustomSelectActiveDescendant(option?.id);
    };

    customSelect.addEventListener("click", (e) => {
      const isOptionClick = (e.target as HTMLElement).closest(".FormSelection__Custom-Option");
      if (!isOptionClick) {
        if (isExpanded()) {
          collapse();
        } else {
          expand();
        }
        // isExpanded() ? collapse() : expand();
      }
    });

    options.forEach(option => {
      option.addEventListener("click", () => selectOption(option));
    });

    const optionSearching = (firstKey: string) => {
      const lowerKey = firstKey.toLowerCase();

      const matchOptions = options.filter(option =>
        option.textContent?.[0]?.toLowerCase() === lowerKey,
      );

      const matchOptionIndexes = matchOptions.map(option => options.indexOf(option));

      if (!matchOptions.length) return null;

      if (!activeIndex || !matchOptionIndexes.includes(activeIndex)) {
        return matchOptions[0];
      }

      const currentMatchIndex = matchOptionIndexes.indexOf(activeIndex);

      if (currentMatchIndex === -1 || currentMatchIndex === matchOptionIndexes.length - 1) {
        return matchOptions[0];
      }

      return matchOptions[currentMatchIndex + 1];
    };

    customSelect.addEventListener("keydown", (e: KeyboardEvent) => {
      const command = getActionFromKey(e, isExpanded());
      const focused = document.activeElement as HTMLElement;
      activeIndex = options.indexOf(focused);
      let nextIndex = activeIndex;

      switch (command) {
        case selectActions.close:
          collapse();
          customSelect.focus();
          break;
        case selectActions.closeSelect:
          if ((document.activeElement as HTMLElement).classList.contains("FormSelection__Custom-Option")) {
            (document.activeElement as HTMLElement).click();
          } else {
            collapse();
            customSelect.focus();
          }
          break;
        case selectActions.first:
          nextIndex = 0;
          if (!isExpanded()) expand();
          focusOption(options[nextIndex]);
          break;
        case selectActions.last:
          nextIndex = options.length - 1;
          if (!isExpanded()) expand();
          focusOption(options[nextIndex]);
          break;
        case selectActions.next:
          nextIndex = (activeIndex + 1) % options.length;
          focusOption(options[nextIndex]);
          break;
        case selectActions.open:
          expand();
          break;
        case selectActions.previous:
          nextIndex = (activeIndex - 1 + options.length) % options.length;
          focusOption(options[nextIndex]);
          break;
        case selectActions.search:
          focusOption(optionSearching(e.key));
          break;
      }
    });

    document.addEventListener("click", (e) => {
      if (!customSelect.contains(e.target as Node) && isExpanded()) {
        collapse();
      }
    });

    customSelect.addEventListener("focusout", () => {
      setTimeout(() => {
        if (!customSelect.contains(document.activeElement)) {
          collapse();
        }
      }, 0);
    });

    customSelect.addEventListener("focus", () => {
      setTimeout(() => {
        if (!customSelect.contains(document.activeElement) && isExpanded()) {
          collapse();
        }
      }, 0);
    });
  });
}

function init(){
  initSelect();
}

export default { init };
